"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invoke = void 0;
const invoke = async (endpoint, body) => {
    const response = await fetch(`https://golfsavers-functions.azurewebsites.net/api/${endpoint}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    });
    if (!response.ok) {
        return {
            body: response.statusText,
            status: response.status,
            success: false,
        };
    }
    const obj = {
        body: await response.json(),
        status: 200,
        success: true,
    };
    return obj;
};
exports.invoke = invoke;
